/* Paola Milano swatches — behaviour that Swatch King added on top of the theme's variant picker.
   Variant selection itself stays in assets/product-page.js (it listens to [data-option-button]).
   - marks values whose combination with the current selection is sold out / missing (.is-soldout)
   - SOLD OUT / SALE badges on colour swatches (Swatch King badge rules)
   - moves the Kiwi size chart link next to the "Taglia" / "Numero di scarpe" label */
(function () {
  function init(root) {
    var section = root.closest('[data-product-section]') || document;
    var jsonNode = section.querySelector('[data-product-json]');
    var product = null;
    try {
      product = jsonNode ? JSON.parse(jsonNode.textContent) : null;
    } catch (error) {
      product = null;
    }

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-option-button]'));

    if (product && product.variants && product.options) {
      var optionNames = product.options.map(function (option) {
        return typeof option === 'string' ? option : option.name;
      });

      var selectedOptions = function () {
        return optionNames.map(function (name) {
          var active = buttons.filter(function (button) {
            return button.dataset.optionName === name && button.classList.contains('is-active');
          })[0];
          return active ? active.dataset.optionValue : null;
        });
      };

      var refresh = function () {
        var selected = selectedOptions();
        buttons.forEach(function (button) {
          var index = optionNames.indexOf(button.dataset.optionName);
          var match = product.variants.filter(function (variant) {
            return variant.options.every(function (value, i) {
              if (i === index) return value === button.dataset.optionValue;
              return selected[i] == null || value === selected[i];
            });
          })[0];
          button.classList.toggle('is-soldout', !match || !match.available);
        });
      };

      var addBadges = function () {
        root.querySelectorAll('.pm-sw__option--image').forEach(function (group) {
          var groupButtons = Array.prototype.slice.call(group.querySelectorAll('[data-option-button]'));
          if (!groupButtons.length) return;
          var index = optionNames.indexOf(groupButtons[0].dataset.optionName);
          var stats = groupButtons.map(function (button) {
            var variants = product.variants.filter(function (variant) {
              return variant.options[index] === button.dataset.optionValue;
            });
            return {
              button: button,
              soldOut: variants.every(function (variant) { return !variant.available; }),
              sale: variants.some(function (variant) {
                return variant.compare_at_price && (variant.compare_at_price - variant.price) / variant.compare_at_price >= 0.05;
              })
            };
          });
          var allOnSale = stats.every(function (stat) { return stat.sale; });

          stats.forEach(function (stat) {
            var label = stat.soldOut ? 'SOLD OUT' : (stat.sale && !allOnSale ? 'SALE' : '');
            if (!label) return;
            var frame = stat.button.querySelector('.pm-sw__frame');
            if (!frame) return;
            var badge = document.createElement('span');
            badge.className = 'pm-sw__badge pm-sw__badge--' + (stat.soldOut ? 'sold-out' : 'sale');
            badge.textContent = label;
            frame.appendChild(badge);
          });
        });
      };

      root.addEventListener('click', function (event) {
        if (!event.target.closest('[data-option-button]')) return;
        window.setTimeout(refresh, 0);
      });

      addBadges();
      refresh();
    }

    var slot = root.querySelector('[data-pm-size-chart-slot]');
    if (!slot) return;

    var moveSizeChart = function () {
      document
        .querySelectorAll('.ks-chart-container, .ks-calculator-container.sizing-calculator-container')
        .forEach(function (node) {
          if (!slot.contains(node)) slot.appendChild(node);
        });
    };

    moveSizeChart();
    var observer = new MutationObserver(moveSizeChart);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 20000);
  }

  document.querySelectorAll('[data-pm-swatches]').forEach(init);
})();
